import { createTable, Link as LinkMagik, Pagination } from "@inmagik/magik-ui"
import { FiltersBase, Persona } from "../../types"
import { Link } from "react-router-dom"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"

const Table = createTable<Persona>()

export function TablePersone({
  persone,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  persone: Persona[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {

  const numPages = useMemo(() => {
    if (!persone) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [persone, count])
  
  return (
    <Table
      data={persone}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Column
        title="Nome"
        name="nome"
        sortable
        width="minmax(max-content, 1fr)"
        render={(persona) => (
          <Link to={`/opere/persone/${persona.id}`}>
            <LinkMagik className="text-dark">{persona.nome}</LinkMagik>
          </Link>
        )}
        stickyLeft
      />
      <Table.Column
        title="Anno di nascita"
        name="anno_nascita"
        sortable
        width="minmax(max-content, 1fr)"
        render={(persona) => (
          persona.anno_nascita
        )}
        
      />
      <Table.Column
        title="Anno di morte"
        name="anno_morte"
        sortable
        width="minmax(max-content, 1fr)"
        render={(persona) => (
          persona.anno_morte
        )}
        
      />
      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} persone
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>

    </Table>
  )
}
